import { jsx as l } from "react/jsx-runtime";
import { c as f } from "../../../clsx-OuTLNxxd.js";
import { useState as k } from "react";
const v = "_stepper_1qhw1_29", w = "_dot_1qhw1_34", q = "_active_1qhw1_44", y = "_clickable_1qhw1_47", r = {
  stepper: v,
  dot: w,
  active: q,
  clickable: y
}, d = ({
  stepsCount: p,
  onStepChange: c,
  currentStep: n,
  initialStep: _ = 0,
  isClickable: o = !1
}) => {
  const [i, m] = k(_), u = n ?? i, s = (t) => t === u, a = (t) => {
    o && !s(t) && (m(t), c == null || c(t));
  };
  return /* @__PURE__ */ l("div", { className: r.stepper, children: Array.from({ length: p }).map((t, e) => /* @__PURE__ */ l(
    "button",
    {
      className: f(r.dot, s(e) && r.active, o && r.clickable),
      onClick: () => a(e),
      tabIndex: 0,
      onKeyDown: (b) => b.key === "Enter" && a(e),
      "aria-pressed": s(e),
      "aria-label": `Step ${e + 1}`
    },
    e
  )) });
};
export {
  d as StepperDots
};
